/* Stylesheet */

.avatar {
  height: 48px;
  width: 48px;
  box-shadow: var(--ion-box-shadow);

  .image {
    height: 48px;
    width: 48px;
  }
}
